// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Rollup of the last result of every test case linked to the risk. Coverage says a risk has tests; verification says what those tests reported. Counts come from each linked test case's latest execution anywhere in the project.
 * @export
 * @interface RiskVerification
 */
export interface RiskVerification {
  /**
   * failed when any linked test case last failed; passed when every linked test case last passed; partial when some passed and the rest were never executed; not_run when test cases are linked but none has a result; no_tests when the risk has no linked test case.
   * @type {string}
   * @memberof RiskVerification
   */
  state: RiskVerificationStateEnum;
  /**
   * Linked test cases whose last result was passed
   * @type {number}
   * @memberof RiskVerification
   */
  passed: number;
  /**
   * Linked test cases whose last result was failed
   * @type {number}
   * @memberof RiskVerification
   */
  failed: number;
  /**
   * Linked test cases with no usable result: never executed, skipped or blocked
   * @type {number}
   * @memberof RiskVerification
   */
  notVerified: number;
}

export function RiskVerificationFromJSON(json: any): RiskVerification {
  return {
    state: json["state"],
    passed: json["passed"],
    failed: json["failed"],
    notVerified: json["not_verified"],
  };
}

export function RiskVerificationToJSON(value?: RiskVerification): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    state: value.state,
    passed: value.passed,
    failed: value.failed,
    not_verified: value.notVerified,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum RiskVerificationStateEnum {
  Passed = "passed",
  Failed = "failed",
  Partial = "partial",
  NotRun = "not_run",
  NoTests = "no_tests",
}
